module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCgk8dGl0bGUgLz4NCgk8ZyBkYXRhLW5hbWU9IkxheWVyIDIiIGlkPSJMYXllcl8yIj4NCgkJPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI5LDZIM0ExLDEsMCwwLDAsMiw3VjI1YTEsMSwwLDAsMCwxLDFIMjlhMSwxLDAsMCwwLDEtMVY3QTEsMSwwLDAsMCwyOSw2Wk03LDIzYTEsMSwwLDAsMS0xLTFWMTBBMSwxLDAsMCwxLDcsOSw3LDcsMCwwLDEsNywyM1ptMTktMWExLDEsMCwwLDEtMSwxQTcsNywwLDAsMSwyNSw5YTEsMSwwLDAsMSwxLDFaIiAvPg0KCTwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/dolby.svg
// module id = svF7
// module chunks = 12